<template>
  <v-container
    id="detalhe-principais-clientes-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row v-if="!paginaEnable">
      <h1>
        Usuário não tem permissão a essa página não existente
      </h1>
    </v-row>
    <v-row v-else>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <v-row>
          <v-col
            cols="12"
            class="container"
          >
            <v-container>
              <v-col
                cols="12"
              >
                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                    md="6"
                    lg="2"
                  >
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="computedPrimeiroDia"
                          label="Data Inical"
                          persistent-hint
                          prepend-icon="mdi-calendar"
                          v-bind="attrs"
                          readonly
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        v-model="primeiroDia"
                        no-title
                        @input="menu = false"
                      />
                    </v-menu>
                  </v-col>
                  <v-col
                    id="menu1"
                    cols="12"
                    sm="6"
                    md="4"
                    lg="2"
                  >
                    <v-menu
                      v-model="menu1"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="computedDateFormatted"
                          label="Data Final"
                          persistent-hint
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        v-model="ultimoDia"
                        no-title
                        @input="menu1 = false"
                      />
                    </v-menu>
                  </v-col>
                  <v-col
                    id="selectEmpresa"
                    cols="12"
                    sm="6"
                    md="4"
                    lg="6"
                  >
                    <v-select
                      v-model="select"
                      :items="empresa"
                      item-value="id"
                      item-text="nomeExibicao"
                      label="Empresas"
                      multiple
                      return-object
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="6"
                    lg="2"
                  >
                    <v-btn
                      id="btnRefazer"
                      class="col-12 lg-12 text-h4"
                      small
                      :color="corPrimaria"
                      dark
                      @click="updateDate()"
                    >
                      <v-icon>
                        mdi-reload-alert
                      </v-icon>
                      Refazer
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-container>
            <v-divider class="mb-5" />
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <div>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <v-card
                        class="mx-auto"
                        outlined
                      >
                        <v-list-item three-line>
                          <v-list-item-content
                            id="listItemClientesBaseAtendimento"
                            class="pr-10"
                            :style="dynamicPaddingClienteInativos"
                          >
                            <div class="text-overline mb-4 highlighted-item">
                              Detalhe Devolução
                            </div>
                            <v-btn
                              id="btnPrint"
                              class="col-12 lg-12"
                              small
                              :disabled="enableBtn"
                              :color="corPrimaria"
                              dark
                              :loading="imprimindo"
                              @click="imprimir()"
                            >
                              <v-icon>
                                mdi-printer
                              </v-icon>
                              Imprimir
                            </v-btn>
                          </v-list-item-content>
                          <v-tooltip top>
                            <template
                              v-slot:activator="{ on, attrs }"
                            >
                              <v-icon
                                id="iconInformationFatxMetaComercial4"
                                class="text-left"
                                v-bind="attrs"
                                v-on="on"
                                @mouseover="enableTexto('342')"
                              >
                                mdi-information-outline
                              </v-icon>
                            </template>
                            <div
                              v-if="codigo === '342'"
                              v-html="textoDetalhesDevolucao"
                            />
                          </v-tooltip>
                        </v-list-item>
                        <v-card-actions>
                          <v-row>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                              lg="12"
                            >
                              <div
                                v-if="loading"
                                :style="styleObject"
                                class="text-center"
                              >
                                <v-icon
                                  light
                                  class="custom-loader"
                                  :style="styleObject"
                                >
                                  mdi-cached
                                </v-icon>
                                Carregando dados...
                              </div>
                              <div
                                v-else-if="error"
                                class="alert alert-danger"
                              >
                                {{ error }}
                              </div>
                              <div>
                                <v-row>
                                  <v-col
                                    cols="12"
                                    sm="12"
                                    md="12"
                                    lg="12"
                                  >
                                    <v-data-table
                                      id="headersDevolucao"
                                      :headers="headersDevolucao"
                                      :items="dadosDevolucao"
                                      :items-per-page="dadosDevolucao.length"
                                      fixed-header
                                      disable-sort
                                      hide-default-footer
                                      class="elevation-1"
                                      style="color: black"
                                    />
                                  </v-col>
                                </v-row>
                              </div>
                            </v-col>
                          </v-row>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import Vendas3 from '../../../../../services/vendas3'
  import Permissao from '../../../../../services/menu'
  import JSPDF from 'jspdf'
  import 'jspdf-autotable'

  export default {
    name: 'DashboardFaturamentoProdutos',
    components: {
      DashboardCoreSnackbar: () => import('../../../components/core/Snackbar'),
    },

    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObjectIcon: {
        color: '#4780b8',
      },
      styleObject: {
        color: localStorage.corPrimaria,
      },
      paginaEnable: false,
      primeiroDia: (new Date(localStorage.dataInicial)).toISOString().substr(0, 10),
      ultimoDia: (new Date(localStorage.dataFinal)).toISOString().substr(0, 10),
      select: JSON.parse(localStorage.getItem('empresaId')),
      empresa: [],
      menu: false,
      menu1: false,
      loading: false,
      error: null,
      dataInicialImpressao: false,
      dataFinalImpressao: false,
      codigo: 0,
      orientacao: [],
      textoDetalhesDevolucao: '',
      headersDevolucao: [
        { text: 'Data', value: 'data', width: '150px', class: 'black--text title' },
        { text: 'Cliente', value: 'cliente', width: '150px', class: 'black--text title' },
        { text: 'Vendedor', value: 'vendedor', width: '150px', class: 'black--text title' },
        { text: 'Devolução', value: 'devolucao', width: '150px', align: 'right', class: 'black--text title' },
      ],
      dadosDevolucao: [],
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      enableBtn: true,
      dynamicPaddingClienteInativos: '',
      imprimindo: false,
    }),

    computed: {
      computedDateFormatted () {
        return this.formatDate(this.ultimoDia)
      },

      computedPrimeiroDia () {
        return this.formatDatePrimeiroDia(this.primeiroDia)
      },
    },

    beforeDestroy () {
      window.removeEventListener('resize', this.updateDynamicPadding)
    },

    mounted () {
      this.updateDynamicPadding()

      window.addEventListener('resize', this.updateDynamicPadding)

      if (localStorage.tokencontrato) {
        this.usuarioIdentificado = true

        this.paginaEnable = true

        this.orientacao = JSON.parse(localStorage.getItem('orientacaoVendas'))

        Permissao.showEmpresas(localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            var i = 0

            for (i in resposta.data.empresas) {
              this.empresa.push(resposta.data.empresas[i])
            }
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        localStorage.removeItem('usuarioIdentificado')
        this.$router.push('/login')
      }
    },

    methods: {
      updateDynamicPadding () {
        if (window.innerWidth > 1380) {
          this.dynamicPaddingClienteInativos = 'padding-right: 106rem !important'
        } else if (window.innerWidth > 380 && window.innerWidth < 600) {
          this.dynamicPaddingClienteInativos = 'padding-right: 11rem !important'
        } else {
          this.dynamicPaddingClienteInativos = 'padding-right: 68rem !important'
        }
      },

      formatDate (date) {
        if (!date) {
          return null
        }

        var dataLimite = new Date(new Date().getFullYear(), new Date().getMonth() + 3, 0).toISOString().substr(0, 10)

        if (date > dataLimite) {
          this.showSnackbar('error', 5000, 'Filtro de datas não podem ser maiores que 2 meses da data atual')

          var data = new Date(new Date().getFullYear(), new Date().getMonth() + 2, 0).toISOString().substr(0, 10)

          const [year, month, day] = data.split('-')

          return `${day}/${month}/${year}`
        }

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDatePrimeiroDia (date) {
        if (!date) {
          return null
        }

        var dataLimite = new Date(new Date().getFullYear(), new Date().getMonth() - 2, 1).toISOString().substr(0, 10)

        if (date < dataLimite) {
          this.showSnackbar('error', 5000, 'Filtro de datas não podem ser menores que 2 meses da data atual')

          const [year, month, day] = dataLimite.split('-')

          return `${day}/${month}/${year}`
        }

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      enableTexto (value) {
        var i = 0

        this.codigo = value

        for (i in this.orientacao) {
          if (this.orientacao[i].codigo === '342') {
            this.textoDetalhesDevolucao = this.orientacao[i].descricao
          }
        }
      },

      updateDate () {
        this.dadosDevolucao = []

        this.formatarDatasImpressao()

        this.showDelhamentoDevolucao()
      },

      async imprimir () {
        try {
          this.imprimindo = true

          await setTimeout(() => {
            this.print()
          }, 2000)
        } catch (error) {
          console.error('Erro ao imprimir:', error)
        }
      },

      quebrarString (str, limiteCaracteresPorLinha) {
        const palavras = str.split(' ')
        let linhaAtual = ''
        const linhas = []

        palavras.forEach(palavra => {
          if ((linhaAtual + palavra).length <= limiteCaracteresPorLinha) {
            linhaAtual += palavra + ' '
          } else {
            linhas.push(linhaAtual.trim())
            linhaAtual = palavra + ' '
          }
        })

        if (linhaAtual !== '') {
          linhas.push(linhaAtual.trim())
        }

        return linhas
      },

      async print () {
        try {
          const pdf = new JSPDF('landscape', 'mm')

          // Função para adicionar tabela e controlar quebra de página
          const addTable = async (data, headers, title, posY, fontSize) => {
            pdf.text(title, 15, posY)
            posY += pdf.getTextDimensions(title).h

            pdf.autoTable({
              head: [headers.map(header => ({ content: header.text, styles: { fontSize: fontSize, textColor: [0, 0, 0] } }))],
              body: data.map(row => row.map((cell, index) => {
                const isFaturamentoColumn = index === 3
                return {
                  content: cell,
                  styles: {
                    fontSize: 8,
                    textColor: [0, 0, 0],
                    halign: isFaturamentoColumn ? 'right' : 'left',
                  },
                }
              })),
              startY: posY,
              styles: { fontSize: fontSize },
            })

            posY = 20

            return posY
          }

          let posYFiltros = 10

          const title = 'Filtros selecionados'
          pdf.text(title, 105, posYFiltros)

          const dataInicial = this.primeiroDia.substr(8) + '/' + this.primeiroDia.substr(5, 2) + '/' + this.primeiroDia.substr(0, 4)
          const ultimoDia = this.ultimoDia.substr(8) + '/' + this.ultimoDia.substr(5, 2) + '/' + this.ultimoDia.substr(0, 4)

          const datas = 'Data inicial: ' + dataInicial + ' - Data final: ' + ultimoDia
          posYFiltros += 10
          pdf.setFontSize(10)
          pdf.text(datas, 15, posYFiltros)

          posYFiltros += 10

          const adicionarFiltros = async (pdf, posYFiltros, titulo, dados) => {
            if (dados.length > 0) {
              let texto = titulo + ' '

              for (let i = 0; i < dados.length; i++) {
                texto += dados[i] + ', '
              }

              texto = texto.slice(0, -2)

              const linhas = this.quebrarString(texto, 135)

              linhas.forEach((linha, index) => {
                if (posYFiltros === 200) {
                  pdf.addPage()

                  posYFiltros = 10

                  pdf.text(linha, 15, posYFiltros)

                  posYFiltros += 10
                } else {
                  pdf.text(linha, 15, posYFiltros)

                  posYFiltros += 10
                }
              })
            }

            return posYFiltros
          }

          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Empresa(s) Selecionada(s):', this.select.map(e => e.nomeExibicao))

          if (posYFiltros > 70) {
            pdf.addPage()

            posYFiltros = 10
          }

          const titleTable = 'Detalhe Devoluções'
          const table = this.dadosDevolucao.map(item => [item.data, item.cliente, item.vendedor, item.devolucao])
          posYFiltros = await addTable(table, this.headersDevolucao, titleTable, posYFiltros, 8)

          pdf.save('relatorio_detalhe_devolucao.pdf')
        } catch (error) {
          console.error('Erro ao gerar PDF:', error)
        } finally {
          this.imprimindo = false
        }
      },

      formatarDatasImpressao () {
        var partesInicial = this.primeiroDia.split('-')
        var ano = partesInicial[0]
        var mes = partesInicial[1]
        var dia = partesInicial[2]
        this.dataInicialImpressao = dia + '/' + mes + '/' + ano

        var partesFinal = this.ultimoDia.split('-')
        var anoFinal = partesFinal[0]
        var mesFinal = partesFinal[1]
        var diaFinal = partesFinal[2]
        this.dataFinalImpressao = diaFinal + '/' + mesFinal + '/' + anoFinal
      },

      async showDelhamentoDevolucao () {
        this.loading = true
        this.enableBtn = true

        await Vendas3.showDelhamentoDevolucaoVendas3(this.primeiroDia, this.ultimoDia, this.select, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.enableBtn = false

            this.dadosDevolucao = resposta.data.dadosExibicao.map((item) => {
              var listaDevolucao = ({
                data: item.data,
                cliente: item.cliente,
                vendedor: item.vendedor,
                devolucao: parseFloat(item.devolucao).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
              })

              return listaDevolucao
            })
          } else if (resposta.data.msg === 'Não há faturamento para o período selecionado') {
            this.dadosDevolucao = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },
    },
  }
</script>
<style lang="sass">
  #listItemClientesBaseAtendimento
    margin: -2rem 0 0 -1rem

  .highlighted-item
    background-color: #2863af
    padding: 16px
    color: white
    margin: -1rem 0 0 0

  #btnPrint
    margin: 0 0 0 9rem

  #relatorioClientesFaturados
    margin-left: 0.5rem
    font-size: 14px
    font-weight: bold

  #iconInformationClientesFaturados
    margin-left: 9.5rem
    font-weight: bold

  #headersClientesFaturados
    margin-left: 1.7rem
    margin-right: 1.7rem

  .no-list-style
    list-style-type: none
    padding: 0
    margin: 0

  .no-list-style li
    text-decoration: none

  .hidden
    display: none

  .custom-loader
    animation: loader 1s infinite
    display: flex
    @-moz-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @-webkit-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @-o-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)

</style>
